import { CSSProperties, ReactNode } from 'react';
import { useTheme } from '../context/ThemeContext';
import { useFirstVisit } from '../hooks/useFirstVisit';
import Icon from './Icon';

interface CoachMarkProps {
  storageKey: string;
  title?: string;
  body: ReactNode;
  placement?: 'top' | 'bottom';
  style?: CSSProperties;
}

export default function CoachMark({ storageKey, title, body, placement = 'bottom', style }: CoachMarkProps) {
  const { colors } = useTheme();
  const { shouldShow, dismiss } = useFirstVisit(storageKey);

  if (!shouldShow) return null;

  const arrowSize = 8;
  const arrowStyle: CSSProperties = placement === 'bottom'
    ? { top: -arrowSize, borderBottom: `${arrowSize}px solid ${colors.accent}` }
    : { bottom: -arrowSize, borderTop: `${arrowSize}px solid ${colors.accent}` };

  return (
    <div
      role="status"
      style={{
        position: 'relative',
        display: 'flex', alignItems: 'flex-start', gap: 10,
        padding: '12px 14px', borderRadius: 12,
        backgroundColor: colors.accent, color: '#000000',
        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.18)',
        ...style,
      }}
    >
      <span
        aria-hidden
        style={{
          position: 'absolute', left: 18,
          width: 0, height: 0,
          borderLeft: `${arrowSize}px solid transparent`,
          borderRight: `${arrowSize}px solid transparent`,
          ...arrowStyle,
        }}
      />
      <Icon name="lightbulb" size={14} color="#000000" />
      <div style={{ flex: 1, minWidth: 0 }}>
        {title && <div style={{ fontSize: 14, fontWeight: 800, marginBottom: 2 }}>{title}</div>}
        <div style={{ fontSize: 14, lineHeight: 1.45, fontWeight: 500 }}>{body}</div>
      </div>
      <button
        onClick={dismiss}
        aria-label="Dismiss tip"
        style={{
          background: 'transparent', border: 'none', cursor: 'pointer',
          color: '#000000', padding: 4, marginTop: -2,
          minWidth: 28, minHeight: 28,
        }}
      >
        <Icon name="times" size={12} color="#000000" />
      </button>
    </div>
  );
}
